module.exports = __webpack_public_path__ + "static/media/Phase-1-Takeout-Curbside.392e95d1.pdf";